import React from "react";
import { useNavigate } from "react-router-dom";
import { Settings, LogOut, ExternalLink } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { UserAvatar } from "@/components/common";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";

export const ROLE_LABEL = { Sales: "Salg", Engineering: "Ingeniør", "Sales manager": "Salgssjef", Management: "Ledelse" };

export function UserMenu({ children, align = "end", side = "bottom", testId = "user-menu" }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>{children}</DropdownMenuTrigger>
      <DropdownMenuContent align={align} side={side} sideOffset={8} className="w-64 rounded-2xl border-black/[0.06] p-1.5 shadow-float" data-testid={`${testId}-content`}>
        <DropdownMenuLabel className="flex items-center gap-3 px-2 py-2 font-normal">
          <UserAvatar name={user?.name} initials={user?.initials} color={user?.color} src={user?.avatar_url} size="lg" className="h-10 w-10" />
          <span className="min-w-0 leading-tight">
            <span className="block truncate text-[13.5px] font-semibold" data-testid={`${testId}-name`}>{user?.name}</span>
            <span className="block truncate text-[11.5px] text-muted-foreground">{ROLE_LABEL[user?.role] || user?.role}{user?.title ? ` · ${user.title}` : ""}</span>
          </span>
        </DropdownMenuLabel>
        <DropdownMenuSeparator className="bg-black/[0.06]" />
        <DropdownMenuItem onSelect={() => navigate("/settings")} className="h-9 cursor-pointer gap-2.5 rounded-lg px-2.5 text-[13px]" data-testid={`${testId}-settings`}>
          <Settings className="h-4 w-4 text-muted-foreground" /> Innstillinger
        </DropdownMenuItem>
        <DropdownMenuItem onSelect={() => window.open("/foresporsel", "_blank", "noopener")} className="h-9 cursor-pointer gap-2.5 rounded-lg px-2.5 text-[13px]" data-testid={`${testId}-public-form`}>
          <ExternalLink className="h-4 w-4 text-muted-foreground" /> Skjemaet kunden ser
        </DropdownMenuItem>
        <DropdownMenuSeparator className="bg-black/[0.06]" />
        <DropdownMenuItem onSelect={() => { logout(); navigate("/login"); }} className="h-9 cursor-pointer gap-2.5 rounded-lg px-2.5 text-[13px]" data-testid={`${testId}-logout`}>
          <LogOut className="h-4 w-4 text-muted-foreground" /> Logg ut
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
